import { render, staticRenderFns } from "./ServiceDisruptions.vue?vue&type=template&id=4630d7c5&scoped=true&"
import script from "./ServiceDisruptions.vue?vue&type=script&lang=js&"
export * from "./ServiceDisruptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630d7c5",
  null
  
)

export default component.exports